import BtSummary from '@/components/bt-summary/BtSummary'

const BtSummaryRouter = [
  {
    path: 'summary',
    name: 'business-trip-summary',
    component: BtSummary
  }
]

export default BtSummaryRouter



// WEBPACK FOOTER //
// ./src/router/BusinessTripSummaryRouter.js